import './App.css';
import React, { useState } from 'react';
import Home from './components/home/home';
import SecurityRoom from './components/securityroom/securityroom';
import FoodPuzzle from './components/puzzle/foodPuzzle/foodpuzzle';
import CarnivalPuzzle from './components/puzzle/carnivalPuzzle/carnivalPuzzle';
import PalacePuzzle from './components/puzzle/palacePuzzle/palacePuzzle';
import FinalPuzzle from './components/puzzle/finalPuzzle/finalPuzzle';
import LandingPage from './components/landing/landing';
import FoodBuildingGame from './components/game/foodBuildGame/foodBuildGame';
import FoodBuildingIntro from './components/introduction/foodBuildingIntro/foodBuildingIntro';
import CarnivalGameIntro from './components/introduction/carnivalGameIntro/carnivalGameIntro';
import HorseGameIntro from './components/introduction/horseGameIntro/horseGameIntro';
import FinalPuzzleIntro from './components/introduction/finalPuzzleIntro/finalPuzzleIntro';
import MidwayGame from './components/game/midwayGame/midwayGame';
import ChressageGame from './components/game/chressageGame/chressageGame';
import Outro from './components/outro/outro';
import Finish from './components/finish/finish';

function App() {

  const initialTimeOut = 30 * 60;
  //const initialTimeOut = 35;

  const [remainingTime, setRemainingTime] = useState(0);

  const [isReversed, seIsReversed] = useState(false);

  const [currentStep, setCurrentStep] = useState("LANDINGPAGE");
  // const [currentStep, setCurrentStep] = useState("FINISH");
  const updateTimerValue = (args) => {
  
    if (args > initialTimeOut) {
      seIsReversed(true);
    }
    setRemainingTime(args);
    
  }

  // disable the right click 
  document.oncontextmenu = function (e) {
    e.preventDefault();
  };

  const goToStep = (event, args) => {
    if (args === "LandingPage") {
     
      seIsReversed(false);
      setRemainingTime(0);
      setCurrentStep("LANDINGPAGE");
      return;
    } else if (args === "SecurityRoomConfirmation") {
    
      setCurrentStep("SECURITYROOM");
      return;
    } else if (args === 'GeneralIntro') {
    
      setCurrentStep("HOME");
      return;
    } else if (args === 'FoodPuzzle') {
    
      setCurrentStep("FOODPUZZLE");
      return;
    } else if (args === 'FoodBuildGame') {
    
      setCurrentStep("FOODBUILDINGGAME");
      return;
    } else if (args === 'CarnivalPuzzle') {
    
      setCurrentStep("CARNIVALPUZZLE");
      return;
    } else if (args === 'PalacePuzzle') {
    
      setCurrentStep("PALACEPUZZLE");
      return;
    } else if (args === 'FinalPuzzleIntro') {
     
      setCurrentStep("FINALPUZZLEINTRO");
      return;
    } else if (args === 'FinalPuzzle') {
    
      setCurrentStep("FINALPUZZLE");
      return;
    } else if (args === 'FoodBuildingIntro') {
    
      setCurrentStep("FOODBUILDINGINTRO");
      return;
    } else if (args === 'CarnivalGameIntro') {
    
      setCurrentStep("CARNIVALGAMEINTRO");
      return;
    } else if (args === 'HorseGameIntro') {
    
      setCurrentStep("HORSEGAMEINTRO");
      return;
    } else if (args === 'MidwayGame') {
     
      setCurrentStep('MIDWAYGAME');
    } else if (args === 'ChressageGame') {
     
      setCurrentStep("CHRESSAGEGAME");
      return;
    } else if (args === 'Outro') {
     
      setCurrentStep("OUTRO");
      return;
    } else if (args === 'FINALSCENE') {
      setCurrentStep("FINISH");
      return;
    }

  }

  switch (currentStep) {
    case 'LANDINGPAGE':
      return <><LandingPage goToStep={goToStep}></LandingPage></>;
    case "HOME":
      return <><Home goToStep={goToStep}></Home></>
    case "SECURITYROOM":
      return <><SecurityRoom goToStep={goToStep} ></SecurityRoom></>
    case "FOODPUZZLE":
      return <><FoodPuzzle goToStep={goToStep} isReversed={isReversed} updateTimerValue={updateTimerValue} initialTimeOut={initialTimeOut} seconds={initialTimeOut} ></FoodPuzzle></>
    case "FOODBUILDINGINTRO":
      return <><FoodBuildingIntro goToStep={goToStep} isReversed={isReversed} updateTimerValue={updateTimerValue} initialTimeOut={initialTimeOut} seconds={remainingTime}></FoodBuildingIntro></>
    case "CARNIVALGAMEINTRO":
      return <><CarnivalGameIntro goToStep={goToStep} isReversed={isReversed} updateTimerValue={updateTimerValue} initialTimeOut={initialTimeOut} seconds={remainingTime}></CarnivalGameIntro></>
    case "HORSEGAMEINTRO":
      return <><HorseGameIntro goToStep={goToStep} isReversed={isReversed} updateTimerValue={updateTimerValue} initialTimeOut={initialTimeOut} seconds={remainingTime}></HorseGameIntro></>
    case "CARNIVALPUZZLE":
      return <><CarnivalPuzzle goToStep={goToStep} isReversed={isReversed} updateTimerValue={updateTimerValue} initialTimeOut={initialTimeOut} seconds={remainingTime} ></CarnivalPuzzle></>
    case "PALACEPUZZLE":
      return <><PalacePuzzle goToStep={goToStep} isReversed={isReversed} updateTimerValue={updateTimerValue} initialTimeOut={initialTimeOut} seconds={remainingTime} ></PalacePuzzle></>
    case "FINALPUZZLE":
      return <><FinalPuzzle goToStep={goToStep} isReversed={isReversed} updateTimerValue={updateTimerValue} initialTimeOut={initialTimeOut} seconds={remainingTime} ></FinalPuzzle></>
    case "FOODBUILDINGGAME":
      return <FoodBuildingGame goToStep={goToStep} isReversed={isReversed} updateTimerValue={updateTimerValue} initialTimeOut={initialTimeOut} seconds={remainingTime} />
    case "MIDWAYGAME":
      return <MidwayGame goToStep={goToStep} isReversed={isReversed} updateTimerValue={updateTimerValue} initialTimeOut={initialTimeOut} seconds={remainingTime} />
    case "CHRESSAGEGAME":
      return <ChressageGame goToStep={goToStep} isReversed={isReversed} updateTimerValue={updateTimerValue} initialTimeOut={initialTimeOut} seconds={remainingTime} />
    case "FINALPUZZLEINTRO":
      return <FinalPuzzleIntro goToStep={goToStep} isReversed={isReversed} updateTimerValue={updateTimerValue} initialTimeOut={initialTimeOut} seconds={remainingTime} ></FinalPuzzleIntro>
    case "OUTRO":
      return <Outro goToStep={goToStep} />
    case "FINISH":
      return <Finish goToStep={goToStep} />
    default:
      return null;
  }

}

export default App;
